import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { SharedModule } from '../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UserAuthenticationRoutingModule } from './user-authentication-routing.module';
import { ActivateAccountComponent } from './activate-account/activate-account.component';


@NgModule({
  declarations: [
    RegisterComponent,
    LoginComponent,
    ActivateAccountComponent
  ],
  imports: [
    CommonModule,
    UserAuthenticationRoutingModule,
    SharedModule,
    RouterModule
  ]
})
export class UserAuthenticationModule { }
